import { type FC } from 'react';
import Image from 'next/image';
import PartnerContent from './PartnerContent';

type PartnerItemProps = {
  name: string;
  description?: string;
  logo: string;
  title?: string;
  backgroundImage?: string;
  slider?: boolean;
};

const PartnerItem: FC<PartnerItemProps> = ({
  name,
  logo,
  title = '',
  backgroundImage = '',
  slider = false,
}) => {
  return (
    <div
      className={`relative w-full rounded-5xl overflow-hidden cursor-pointer ${
        !backgroundImage ? 'bg-black-to-primary' : ''
      }
      ${slider ? 'h-[400px]' : 'aspect-square'}
      `}
    >
      {backgroundImage && (
        <Image src={backgroundImage} alt={name} fill className="rounded-5xl object-cover" />
      )}

      <PartnerContent logo={logo} name={name} title={title} />
    </div>
  );
};

export default PartnerItem;
